import { render, staticRenderFns } from "./TrainerPrimarySchools.vue?vue&type=template&id=2514ec8f&scoped=true&"
import script from "./TrainerPrimarySchools.vue?vue&type=script&lang=js&"
export * from "./TrainerPrimarySchools.vue?vue&type=script&lang=js&"
import style0 from "./TrainerPrimarySchools.vue?vue&type=style&index=0&id=2514ec8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2514ec8f",
  null
  
)

export default component.exports